import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { EnforcementService } from 'src/app/Services/enforcement.service';
import { Busyable } from 'src/app/shared/editors/busyable';

@Component({
    selector: 'app-printer',
    templateUrl: './printer.component.html',
    styleUrls: ['./printer.component.scss'],
    standalone: false
})
export class PrinterComponent extends Busyable implements OnInit {
  public Model: any = null;

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    public enforcementService: EnforcementService
  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    const id = this.route.snapshot.params['id'];
    if (id) {
      await this.loadPrinter(id);
    }
  }

  private async loadPrinter(id: string): Promise<void> {
    try {
      this.Busy();
      this.Model = await this.apiService.Get(`enforcement/printers/${id}`);
    } finally {
      this.StopBusy();
    }
  }
} 
